// src/components/Footer.js
import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gray-800 text-white mt-auto">
      <div className="max-w-7xl mx-auto py-8 px-4">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="mb-4 md:mb-0 text-center md:text-left">
            <h3 className="text-lg font-bold">Flex Logistics Management</h3>
            <p className="text-gray-400 text-sm">Reliable shipping solutions</p>
          </div>

          {/* Links & Compliance Notice Section */}
          <div className="flex flex-col items-center md:items-start space-y-2 text-sm">
            <div className="flex items-center space-x-6">
              <Link to="/privacy-policy" className="text-gray-300 hover:text-white transition-colors">
                Privacy Policy
              </Link>
              <Link to="/terms" className="text-gray-300 hover:text-white transition-colors">
                Terms & Conditions
              </Link>
            </div>
            <p className="text-gray-400 text-xs max-w-md text-center md:text-left">
              Mobile information and messaging consent will not be shared with third parties or affiliates for marketing or promotional purposes.
            </p>
          </div>

          <div className="text-center md:text-right text-sm">
            <p className="text-gray-400">
              &copy; {new Date().getFullYear()} Flex Logistics Management. All rights reserved.
            </p>
            <p className="text-gray-500 text-xs mt-1">
              Contact: flexlogisticsmanagement1@gmail.com
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}